import { render, staticRenderFns } from "./samecityMultiScanin.vue?vue&type=template&id=2079975c&scoped=true"
import script from "./samecityMultiScanin.vue?vue&type=script&lang=js"
export * from "./samecityMultiScanin.vue?vue&type=script&lang=js"
import style0 from "./samecityMultiScanin.vue?vue&type=style&index=0&id=2079975c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079975c",
  null
  
)

export default component.exports